import { Component, Input } from '@angular/core';
import { ContactPerson } from '../../models/contact';
import { AvatarComponent } from '../../../../components/avatar/avatar.component';
import { ContactRowsComponent } from '../contact-rows/contact-rows.component';

@Component({
  selector: 'app-contact-item',
  imports: [AvatarComponent, ContactRowsComponent],
  templateUrl: './contact-item.component.html',
  styleUrl: './contact-item.component.scss',
  standalone: true
})
export class ContactItemComponent {
  @Input() contact: ContactPerson | null = null;
}
